import { APIError } from '../../../../../utils'

export const isFecImportTimeoutFetchError = (error: unknown): boolean => {
  if (!(error instanceof APIError)) {
    return false
  }

  return error.statusCode === 408 || error.statusCode === 504
}
